export enum WTextViewMode {
  TEXTAREA = 'TEXTAREA',
  DIALOG = 'DIALOG'
}
